import { LogOut, User } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@repo/ui/components/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { NavLink } from 'react-router';
import { useAtomValue } from 'jotai';
import { logout } from '@repo/api-client/lib/auth';
import { userAtom } from '@repo/api-client/stores/auth';
import { urlProfile } from '@/urls';
import { useCurrentClub } from '@/hooks/use-current-club';

export function UserAvatar() {
  const club = useCurrentClub();
  const user = useAtomValue(userAtom);

  const userEmail = user?.email ?? '  ';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 outline-none cursor-pointer">
        <Avatar>
          <AvatarImage src={user?.picture} />
          <AvatarFallback>{userEmail.charAt(0).toUpperCase()}</AvatarFallback>
        </Avatar>
        <div className="text-sm font-medium">{userEmail}</div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="min-w-[calc(var(--spacing-sidebar)-15px)] rounded-lg bg-white"
        side="top"
        align="center"
      >
        <DropdownMenuItem asChild>
          <NavLink
            viewTransition
            to={urlProfile(club.id)}
            className="cursor-pointer hover:bg-neutral-50"
          >
            <User />
            Perfil
          </NavLink>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={logout} className="cursor-pointer hover:bg-neutral-50">
          <LogOut />
          Salir
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
